function lastArrayEach (obj, iterate, context) {
  for (var len = obj.length - 1; len >= 0; len--) {
    iterate.call(context, obj[len], len, obj)
  }
}

module.exports = lastArrayEach



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/lastArrayEach.js
// module id = md7t
// module chunks = 141